import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { IAppState } from '../../store/interface/app.state.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IUser } from '../../user/interfaces/user.interface';
import { UserTypes } from '../../shared/enum/user-types.enum';

@Injectable()
export class SystemUserGuard implements CanActivate {
    constructor(
        private store: Store<IAppState>,
        private router: Router,
    ) {}

    canActivate(): Observable<boolean | UrlTree> {
        return this.store
            .select((state) => state.user.loggedInUser)
            .pipe(
                map((user: IUser | null) => {
                    if (user && user.userType && user.userType.key === UserTypes.TT_USER) {
                        if (user.tenant?.id == null) {
                            return true;
                        } else {
                            return this.router.parseUrl('/');
                        }
                    }
                    return this.router.parseUrl('/');
                }),
            );
    }
}
